import { ArrowRight, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "@/components/Reveal";

const PROJECTS = [
  {
    title: "Rénovation d'un appartement",
    tag: "Rénovation",
    img: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-7",
  },
  {
    title: "Rénovation complète d'une maison",
    tag: "Rénovation",
    img: "https://images.unsplash.com/photo-1758448755969-8791367cf5c5?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-5",
  },
  {
    title: "Salle de bain",
    tag: "Aménagement",
    img: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-5",
  },
  {
    title: "Extension & extérieur",
    tag: "Extension",
    img: "https://images.unsplash.com/photo-1628744876497-eb30460be9f6?crop=entropy&cs=srgb&fm=jpg&q=85",
    span: "md:col-span-7",
  },
];

export const Realisations = () => (
  <section id="realisations" data-testid="realisations-section" className="bg-ivory py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-cognac sm:text-sm">
              Réalisations
            </p>
            <h2 className="mt-4 font-display text-4xl font-medium tracking-tight text-navy sm:text-6xl">
              Des projets qui changent <span className="italic text-sage">le quotidien.</span>
            </h2>
          </div>
          <button
            data-testid="realisations-more"
            onClick={() => toast.info("La galerie complète de nos réalisations arrive bientôt.")}
            className="group flex items-center gap-2 rounded-full border border-navy/20 px-6 py-3 text-sm font-bold text-navy transition-colors duration-300 hover:border-navy hover:bg-navy hover:text-white"
          >
            Voir nos réalisations
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </div>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12">
        {PROJECTS.map((p, i) => (
          <Reveal key={p.title} delay={(i % 2) * 0.08} className={`col-span-1 ${p.span}`}>
            <figure
              data-testid={`realisation-${i}`}
              className="group relative cursor-pointer overflow-hidden rounded-3xl"
            >
              <img
                src={p.img}
                alt={p.title}
                loading="lazy"
                className="h-72 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 sm:h-80"
              />
              <span className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
              <span className="absolute left-5 top-5 rounded-full bg-white/85 px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-navy backdrop-blur-sm">
                {p.tag}
              </span>
              <figcaption className="absolute inset-x-5 bottom-5 flex items-center justify-between gap-3">
                <span className="font-display text-xl font-medium text-white sm:text-2xl">{p.title}</span>
                <span className="rounded-full bg-white/15 p-2.5 text-white backdrop-blur-sm transition-colors duration-300 group-hover:bg-cognac">
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
